// INFO: такая перезагрузка даёт возможность корректной работе мобильных приложений.
// другая перезагрузка, например, window.location.reload() - приводит к тому, что cordova не загружается
export const reload = () => window.location.assign('');
